import type { Drill } from '../game/drills';
import type { DrillResult } from '../game/types';
import { must } from './dom';

export interface YardRow {
  id: string;
  name: string;
  /** The lesson, in one line. */
  teaches: string;
  /** `null` until the drill has been completed. */
  score: DrillResult | null;
  /** This is the drill currently on the board. */
  current: boolean;
}

/** The yard in authored order: easiest first, within each family. */
export function buildYardRows(
  drills: readonly Drill[],
  done: Record<string, DrillResult>,
  currentId: string | null,
): YardRow[] {
  return drills.map((d) => ({
    id: d.id,
    name: d.name,
    teaches: d.teaches,
    score: done[d.id] ?? null,
    current: d.id === currentId,
  }));
}

/**
 * Stored results keep the tier emoji (it is the share's medal); the UI shows
 * the rank as plain text instead. Same table the archive uses, for the same
 * reason: no emoji renders inside this interface.
 */
const RANK: Record<string, string> = {
  '🏆': 'Superconductor',
  '🥇': 'Master',
  '🥈': 'Journeyman',
  '🥉': 'Apprentice',
};

/** Render the drill list and hand back each row's id on click. */
export function renderYard(rows: YardRow[], onPick: (id: string) => void): void {
  const list = must('yardList');
  list.innerHTML = rows
    .map((row) => {
      const rank = row.score ? (RANK[row.score.tier] ?? '') : '';
      const right = row.score
        ? `<span class="score"><b>${row.score.mw}</b> MW${rank ? ' · ' + rank : ''}</span>`
        : `<span class="unplayed">play</span>`;
      return (
        `<button class="arch-row${row.current ? ' current' : ''}" data-drill="${row.id}">` +
        `<span class="drill-name"><b>${row.name}</b><small>${row.teaches}</small></span>${right}</button>`
      );
    })
    .join('');

  list.querySelectorAll<HTMLButtonElement>('.arch-row').forEach((b) => {
    b.addEventListener('click', () => onPick(String(b.dataset.drill)));
  });
}
